import '../../utils/index.mjs';
import _sfc_main from './src/affix2.mjs';
export { affixEmits, affixProps } from './src/affix.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElAffix = withInstall(_sfc_main);

export { ElAffix, ElAffix as default };
//# sourceMappingURL=index.mjs.map
